import { render, staticRenderFns } from "./invoice-paper.vue?vue&type=template&id=50c038a4"
import script from "./invoice-paper.vue?vue&type=script&lang=js"
export * from "./invoice-paper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports